// Components
import { FooterMainLayout } from "../footer/footer-main-layout";
import { HeaderMainLayout } from "../header/header-main-layout";

// SCSS
import { useEffect } from "react";
import { useAppAlert } from "../../components/app-alert/use-app-alert";
import { LOCALSTORAGEAUTHUSERINFO } from "../../constants/local-storage-constant";
import { useAxiosInterceptors } from "../../hooks/use-axios-interceptors";
import { myPersonalDetailsThunk } from "../../store/personal-details/personal-details-thunk-actions";
import { useAppDispatch } from "../../store/store";
import { getDataFromLocalStorage } from "../../utils/views-utils";
import { BodyMainLayout } from "../body/body-main-layout";
import "./main-layout.scss";

// Component start here
export const MainLayout = () => {
  // const { openDrawer }: any = useMainLayout();
  // const { layout } = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const axiosInstance = useAxiosInterceptors();
  const { openAlert } = useAppAlert();

  const isAuth = getDataFromLocalStorage(LOCALSTORAGEAUTHUSERINFO);

  useEffect(() => {
    if (!!isAuth?.token) {
      dispatch(myPersonalDetailsThunk({ axiosInstance, openAlert }));
    }
  }, []);

  return (
    <div className="flex flex-column min-height-100vh">
      <div className="header margin-outlet-x">
        <div className="position-absolute side-bar-triangle"></div>
        <HeaderMainLayout />
      </div>
      <div className="main-body flex-grow-1 margin-outlet-x">
        <BodyMainLayout />
      </div>
      <div className="footer">
        <FooterMainLayout />
      </div>
    </div>
  );
};
